export class DataProgress {
    public inProgress: number;
    public error: number;
    constructor(data ? : any) {
        this.inProgress = data && data.inProgress ? data.inProgress : 0;
        this.error = data && data.error ? data.error : 0;
     }
}